import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { formatText } from 'core/i18n';
import React from 'react';

export const CompletedMessage = () => {
    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-info-big"
                title={formatText('identity-finishQRCaptureTitle')}
                subtitle={formatText('identity-finishQRCaptureSubtitle')}
                dashTitle={false}
                showFooter={false}
            />
        </div>
    );
};
